import { merge, ScrollablePane, Stack, StackItem, Sticky, StickyPositionType, Text } from '@fluentui/react';
import React, { useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useLotsCommerciaux } from '../../../contexts/lotCommercialContext';
import { useNotifications } from '../../../contexts/notificationContext';
import { ResponsiveSize, useResponsiveSize } from '../../../contexts/responsiveContext';
import Inputs from '../../Pages/Messages/Inputs';
import Footer from '../Footer';
import Header from '../Header';
import MainMessageBar from './MainMessageBar';
import Menu from './Menu';
import Summary from './Summary';

const LayoutOnline = (props) => {

    const { children } = props;

    const { errorMessages, successMessages } = useNotifications();
    const { lotCommercialActif } = useLotsCommerciaux();
    const { nomCommercial, numero } = lotCommercialActif || {};
    const { innerWidth, responsiveSize } = useResponsiveSize();

    const location = useLocation();

    // Reset du scroll au changement de page
    useEffect(() => {
        const scrollablePane = document.querySelector('[data-is-scrollable="true"]');
        if (!!scrollablePane) scrollablePane.scrollTo(0, 0);
    }, [location.pathname])

    // Reset du scroll si nouvelle notification (error ou success)
    // Vu avec Sandrine et Sonia, suffisant pour l'instant ; peut-�tre changer si n�cessaire pour une notification flottante � l'avenir
    useEffect(() => {
        if (errorMessages.length > 0 || successMessages.length > 0) {
            const scrollablePane = document.querySelector('[data-is-scrollable="true"]');
            if (!!scrollablePane) scrollablePane.scrollTo(0, 0);
        }
    }, [errorMessages, successMessages])

    const styles = useMemo(
        () => {

            const contentWidth = innerWidth - 36 - 36; // Largeur moins gutters gauche et droite
            const columnSize = contentWidth / 6;

            let styles = {
                activeItem: {
                    root: {
                        color: "#8A8A8A",
                        display: "inline-block",
                        fontSize: 16,
                        lineHeight: "19px",
                        padding: "10px 35px"
                    }
                },
                content: {
                    root: {
                        backgroundImage: "linear-gradient(to right, #F0F0F0 1px, transparent 1px)",
                        backgroundPosition: -1, // Masquer la premi�re ligne verticale, g�r�e par la gouti�re gauche
                        backgroundSize: columnSize, //72,
                        //borderRight: "1px solid #F0F0F0",
                        flexGrow: 1,
                        paddingBottom: responsiveSize === ResponsiveSize.small && location.pathname === "/messages" ? "unset" : 30, // Messagerie : pas de paddingBottom pour coller la saisie aux bords de l'�cran
                        paddingTop: 30,
                    }
                },
                inner: { root: { minHeight: "100%" } },
                leftGutter: {
                    root: {
                        borderRight: "1px solid #F0F0F0",
                        //backgroundImage: "linear-gradient(to right, #F0F0F0 1px, transparent 1px)", // Lignes verticales retir�es des gouti�res
                        //backgroundSize: 72,
                        flexGrow: 0,
                        minWidth: 36,
                        //rotate: "180deg" // linear-gradient(to left) ne fonctionne pas sur Chrome
                    }
                },
                rightGutter: {
                    root: {
                        //borderLeft: "1px solid #F0F0F0",
                        //backgroundImage: "linear-gradient(to right, #F0F0F0 1px, transparent 1px)", // Lignes verticales retir�es des gouti�res
                        //backgroundSize: 72,
                        flexGrow: 0,
                        minWidth: 36
                    }
                },
                scrollablePane: {
                    root: {
                        height: "100%",
                        overflow: "hidden",
                        position: "relative"
                    },
                    contentContainer: {
                        scrollbarWidth: "none", // Masquer la scrollbar sur lse petits �crans
                        selectors: { "::-webkit-scrollbar": { display: "none" } }
                    }
                }
            };

            if (responsiveSize >= ResponsiveSize.medium)
                styles = merge(styles, {
                    content: {
                        root: {
                            backgroundSize: 120.2, // 120 + 0.2px (les gouti�res gauche et droite g�rent l'affichage de la ligne verticale)
                            //borderRight: "none",
                            flexGrow: 0,
                            paddingTop: 46,
                            width: 721
                        }
                    },
                    //inner: { root: { margin: "0 240px" } },
                    leftGutter: {
                        root: {
                            //backgroundSize: 120,
                            flexGrow: 1
                        }
                    },
                    rightGutter: {
                        root: {
                            //backgroundSize: 120,
                            flexGrow: 1
                        }
                    },
                    scrollablePane: {
                        root: {
                            height: "100%",
                            overflow: "hidden",
                            position: "relative"
                        },
                        contentContainer: {
                            margin: "0 240px",
                            scrollbarWidth: "auto",
                            selectors: { "::-webkit-scrollbar": { display: "auto" } }
                        }
                    }
                });

            return styles;

        },
        [innerWidth, location, responsiveSize]
    );

    return <Stack id="layoutOnline" verticalFill>

        <Sticky stickyPosition={StickyPositionType.Header}>
            <Header />
        </Sticky>

        {responsiveSize === ResponsiveSize.small && <Summary />}

        <ScrollablePane styles={styles.scrollablePane}>
            {responsiveSize === ResponsiveSize.small && !!lotCommercialActif && <Text styles={styles.activeItem}>{[numero, nomCommercial].join(" - ")}</Text>}
            <Stack styles={styles.inner}>
                <MainMessageBar />
                <Stack horizontal grow>
                    <StackItem styles={styles.leftGutter}> </StackItem>
                    <StackItem grow styles={styles.content}>
                        {children}
                    </StackItem>
                    <StackItem styles={styles.rightGutter}> </StackItem>
                </Stack>
            </Stack>
            {responsiveSize >= ResponsiveSize.medium && <Summary />}
        </ScrollablePane>

        {responsiveSize >= ResponsiveSize.medium && <Menu />}

        <Sticky stickyPosition={StickyPositionType.Footer}>
            {responsiveSize === ResponsiveSize.small && location.pathname === "/messages"
                // Masquer le footer si petit �cran et si on affiche la messagerie
                ? <Inputs />
                : <Footer />
            }
        </Sticky>

    </Stack>;

};

export default LayoutOnline;